import { state } from "@src/editors/sharedComponents/TinyMceWidget/hooks";

export const getLoadingDetailsStatus = (state) =>
  state.scheduleAndDetails.loadingDetailsStatus;
export const getLoadingSettingsStatus = (state) =>
  state.scheduleAndDetails.loadingSettingsStatus;
export const getSavingStatus = (state) => state.scheduleAndDetails.savingStatus;
export const getCourseDetails = (state) =>
  state.scheduleAndDetails.courseDetails;
export const getCourseSettings = (state) =>
  state.scheduleAndDetails.courseSettings;
export const courseConfig = (state) => state.scheduleAndDetails.courseConfig;
